import apiClient from '../client';
import type { LoginPayload, LoginResponse, AuthUser } from '@/types';

export const authApi = {
  login: (payload: LoginPayload) =>
    apiClient.post<{ data: LoginResponse }>('/auth/login', payload).then((r) => r.data.data),

  refresh: (refreshToken: string) =>
    apiClient.post<{ data: { accessToken: string } }>('/auth/refresh', { refreshToken })
      .then((r) => r.data.data),

  me: () =>
    apiClient.get<{ data: AuthUser }>('/auth/me').then((r) => r.data.data),

  forgotPassword: (email: string) =>
    apiClient.post<{ data: { message: string } }>('/auth/forgot-password', { email })
      .then((r) => r.data.data),

  resetPassword: (payload: { token: string; password: string; confirmPassword: string }) =>
    apiClient.post<{ data: { message: string } }>('/auth/reset-password', payload)
      .then((r) => r.data.data),
};

